var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconCopy = function SvgIconCopy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#D1D5DB"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.333 10.75v3.5c0 2.917-1.166 4.084-4.083 4.084h-3.5c-2.917 0-4.083-1.167-4.083-4.084v-3.5c0-2.916 1.166-4.083 4.083-4.083h3.5c2.917 0 4.083 1.167 4.083 4.083"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.25 1.667h-3.5c-2.503 0-3.712.866-4.004 2.95-.077.55.384 1.008.941 1.008H9.25c3.5 0 5.125 1.625 5.125 5.125v1.563c0 .557.458 1.019 1.01.941 2.083-.292 2.948-1.5 2.948-4.004v-3.5c0-2.916-1.166-4.083-4.083-4.083"
  }))));
};
export default SvgIconCopy;